//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import parse from 'date-fns/parse'
import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'
import addMonths from 'date-fns/addMonths'
import isBefore from 'date-fns/isBefore'
import isAfter from 'date-fns/isAfter'
import isEqual from 'date-fns/isEqual'

import slugify from 'slugify'



export default {
  props: {
    event: {
      default: false
    }
  },

  computed: {
    itinerary: function() {
      return this.currentItinerary;
    },
  },
  watch: {

  },
  components: {

  },
  filters: {

  },
  data() {
    return { 
      
      
     
    }
  },
  mounted() {

    let self = this;


  },
  methods: {
    printMonthSeparator(month) {
      return month.split(' ')[0]
    },
    printDate(dt, ps, fm) {
      return format( parse(dt, ps, new Date()), fm );
    },
    isoDate(dt, fm) {
      let date = parseISO(dt);
      //'MMMM yy'
      return format(date, fm)
    },
    lastIsoDate(event, fm) {

      let dt = event.dates[ event.dates.length - 1 ];
      let date = parseISO(dt.date);
      //'MMMM yy'
      return format(date, fm)
    },
    togglePlannerItinerary(event) {
      event.data_type = 'event';

      let object = {
        itinerary_id: this.currentSession.id,
        name: event.name,
        venue_name: event.venue_name,
        data_type: 'event',
        object_id: parseInt(event.object_id),
        thumbnail: 'https://api.everwondr.com'+event.thumbnail,
        address_1: event.address_1,
        city: event.city,
        state: event.state,
        next_date: event.raw_next_date,
        last_date: event.end.date + ' 00:00:00',
        zip: event.zip,
        lat: event.lat,
        email: event.email,
        phone: event.phone,
        website: event.website,
        lng: event.lng,
        raw_object: JSON.stringify( event ),
      };

      this.toggleItineraryItem(object);

      //this.$store.commit('toggleItinerary', object);

      this.$forceUpdate();

    },
    inPlanner(listing) {
      return this.itineraryHasItem(listing);
    },
  }
}




// WEBPACK FOOTER //
// ./scripts/components/Event.vue